import { computed, defineComponent, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { InformationAction, InformationGetter } from '@/store/information/information.module';
import { InformationSchema } from '@/store/information/information.validator';
import { Information } from '@/store/information/information.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'InforamtionFormComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    mode: {
      type: String,
      default: 'MILESTONE',
      validator: (value: string) => ['MILESTONE', 'ORGANIZATION', 'AUTHORITY', 'VISIONMISSION'].includes(value)
    }
  },
  setup: (props) => {
    const store = useStore();
    const information = computed<Information>(() => store.getters[InformationGetter.GET]);
    const informationForm = ref<InstanceType<typeof BaseModalComponent>>();
    const title = computed(() => props.mode !== 'MILESTONE'
      ? props.mode !== 'ORGANIZATION'
        ? props.mode !== 'AUTHORITY'
          ? 'วิสัยทัศน์/พันธกิจ'
          : 'อำนาจหน้าที่'
        : 'โครงสร้างและแผนผังองค์กร'
      : 'ประวัติความเป็นมา');

    interface Form {
      id: number;
      milestone: string;
      organization: string;
      authority: string;
      visionMission: string;
    }
    const formData = reactive<Form>({
      id: 1,
      milestone: '',
      organization: '',
      authority: '',
      visionMission: ''
    });
    const validator = computed(() => InformationSchema.validate(formData, { abortEarly: false }));
    const errors = reactive({
      milestone: computed(() => validator.value.error?.details.some((detail) => detail.path[0] === 'milestone')),
      organization: computed(() => validator.value.error?.details.some((detail) => detail.path[0] === 'organization')),
      authority: computed(() => validator.value.error?.details.some((detail) => detail.path[0] === 'authority')),
      visionMission: computed(() => validator.value.error?.details.some((detail) => detail.path[0] === 'visionMission')),
    });
    const isValid = computed(() => !errors.milestone && !errors.organization && !errors.authority && !errors.visionMission);
    const isLoading = computed<boolean>(() => store.getters[InformationGetter.STATUS] === 'init' || store.getters[InformationGetter.STATUS] === 'loading');
    const submited = ref(false);

    // show modal
    const show = () => {
      new Promise<void>((resolve) => {
        formData.milestone = information.value?.milestone;
        formData.organization = information.value?.organization;
        formData.authority = information.value?.authority;
        formData.visionMission = information.value?.visionMission;
        resolve();
      })
      .then(() => informationForm.value?.show());
    };

    // hide modal
    const hide = () => {
      informationForm.value?.hide();
    };

    // clear submit status
    const unsubmit = () => {
      submited.value = false;
    };

    // clear form
    const clearForm = () => {
      new Promise<void>((resolve) => {
        formData.milestone = '';
        formData.organization = '';
        formData.authority = '';
        formData.visionMission = '';
        resolve();
      }).then(() => unsubmit());
    };


    // submit form
    const submitClick = () => {
      submited.value = true;

      if (isValid.value) {
        store.dispatch(InformationAction.UPDATE, formData)
          .then(() => hide());
      }
    };

    return {
      title,
      formData,
      informationForm,
      errors,
      submited,
      isLoading,
      show,
      hide,
      submitClick,
      unsubmit,
      clearForm,
    };
  },
});
